import React from 'react';
import type { DataTableRenderCellParams, DataTableRowEventHandler } from '@/components/custom/erp/data-table-v2';
import { ErpInputTableV2 } from '@/components/custom/erp/input-table-v2';
import { SelectedCellInfo } from '../../hooks/useInvoiceCollectionRows';
import { ChiTietDieuKienThanhToan } from '@/types/schemas';
import { getInvoiceCollectionColumns } from './cols';

interface InvoiceCollectionDayTabProps {
  mode: 'add' | 'edit' | 'view';
  rows: ChiTietDieuKienThanhToan[];
  selectedRowUuid?: string | null;
  selectedCell?: SelectedCellInfo | null;
  onRowClick?: DataTableRowEventHandler<ChiTietDieuKienThanhToan>;
  onCellClick?: (params: DataTableRenderCellParams<ChiTietDieuKienThanhToan>) => void;
  onAddRow: () => void;
  onDeleteRow: () => void;
  onCopyRow: () => void;
  onPasteRow: () => void;
  onMoveRow: (direction: 'up' | 'down') => void;
  onCellValueChange: (rowUuid: string, field: string, newValue: BanHangValue) => void;
}

const InvoiceCollectionDayTab: React.FC<InvoiceCollectionDayTabProps> = ({
  mode,
  rows,
  selectedRowUuid,
  selectedCell,
  onRowClick,
  onCellClick,
  onAddRow,
  onDeleteRow,
  onCopyRow,
  onPasteRow,
  onMoveRow,
  onCellValueChange
}) => {
  const actions = {
    add: onAddRow,
    delete: onDeleteRow,
    copy: onCopyRow,
    paste: onPasteRow,
    moveUp: () => onMoveRow('up'),
    moveDown: () => onMoveRow('down'),
    export: () => {},
    pin: () => {}
  };

  return (
    <ErpInputTableV2
      rows={rows}
      onRowClick={onRowClick}
      onCellClick={onCellClick}
      selectedRowId={selectedRowUuid || undefined}
      columns={getInvoiceCollectionColumns(onCellValueChange)}
      getRowId={row => row?.uuid || ''}
      actions={actions}
      actionsDisabled={mode === 'view'}
      actionOrder={['add', 'delete', 'copy', 'paste', 'moveUp', 'moveDown', 'export', 'pin']}
      pasteTarget={selectedCell}
      showIndexColumn
    />
  );
};

export default InvoiceCollectionDayTab;
